'use strict';

export default function initWikiAccordion() {
	const categoryHeaders = document.querySelectorAll('.wiki-nav__category-header');
	const subsectionLinks = document.querySelectorAll('.wiki-nav__subsection-link');
	const accordionHeaders = document.querySelectorAll('.wiki-accordion__header');
	const wikiSections = document.querySelectorAll('.wiki-section');
	const wikiLanding = document.querySelector('.wiki-landing');
	const wikiLayout = document.querySelector('.wiki-page__layout');

	if (!categoryHeaders.length && !accordionHeaders.length) return;

	// Helper function to build and update URL
	function updateUrl(categoryId, subsectionId, itemSlug = null) {
		let hash = `${categoryId}/${subsectionId}`;
		if (itemSlug) {
			hash += `/${itemSlug}`;
		}
		history.pushState(null, null, `#${hash}`);
	}

	// Helper function to show a specific section
	function showSection(subsectionId, categoryId = null) {
		// Hide landing
		if (wikiLanding) {
			wikiLanding.classList.remove('is-visible');
		}
		if (wikiLayout) {
			wikiLayout.classList.add('is-section-active');
		}

		// Show target section
		wikiSections.forEach(section => {
			if (section.id === subsectionId) {
				section.classList.add('is-visible');
			} else {
				section.classList.remove('is-visible');
			}
		});

		// Update active link
		subsectionLinks.forEach(link => {
			link.classList.remove('is-active');
			if (link.getAttribute('data-subsection') === subsectionId) {
				link.classList.add('is-active');

				// Open parent category
				const parentCategory = link.closest('.wiki-nav__category');
				if (parentCategory) {
					parentCategory.classList.add('is-open');
					parentCategory.querySelector('.wiki-nav__category-header')?.setAttribute('aria-expanded', 'true');
				}
			}
		});
	}

	function showLanding() {
		wikiSections.forEach(section => section.classList.remove('is-visible'));
		subsectionLinks.forEach(link => link.classList.remove('is-active'));
		if (wikiLanding) {
			wikiLanding.classList.add('is-visible');
		}
		if (wikiLayout) {
			wikiLayout.classList.remove('is-section-active');
		}
		document.querySelectorAll('.wiki-accordion__item.is-open').forEach(item => {
			item.classList.remove('is-open');
			item.querySelector('.wiki-accordion__header')?.setAttribute('aria-expanded', 'false');
		});
		history.pushState(null, null, window.location.pathname);
	}

	// Sidebar category toggle
	categoryHeaders.forEach(header => {
		header.addEventListener('click', () => {
			const category = header.closest('.wiki-nav__category');

			// Don't toggle if no subsections
			if (category.classList.contains('no-subsections')) return;

			const isOpen = category.classList.contains('is-open');

			// Close all other categories first
			if (!isOpen) {
				document.querySelectorAll('.wiki-nav__category.is-open').forEach(openCat => {
					if (openCat !== category) {
						openCat.classList.remove('is-open');
						openCat.querySelector('.wiki-nav__category-header')?.setAttribute('aria-expanded', 'false');
					}
				});
			}

			// Toggle current category
			category.classList.toggle('is-open');
			header.setAttribute('aria-expanded', !isOpen);

			if (isOpen) {
				showLanding();
			}
		});
	});

	// Sidebar subsection link click
	subsectionLinks.forEach(link => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const subsectionId = link.getAttribute('data-subsection');
			const categoryId = link.getAttribute('data-category');

			showSection(subsectionId, categoryId);

			// Close all accordion items in the section
			const targetSection = document.getElementById(subsectionId);
			if (targetSection) {
				targetSection.querySelectorAll('.wiki-accordion__item').forEach(item => {
					item.classList.remove('is-open');
					item.querySelector('.wiki-accordion__header')?.setAttribute('aria-expanded', 'false');
				});
			}

			// Scroll to top of content on mobile
			if (window.innerWidth <= 768) {
				const contentArea = document.querySelector('.wiki-page__content');
				if (contentArea) {
					const headerOffset = 100;
					const elementPosition = contentArea.getBoundingClientRect().top;
					const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				}
			}

			// Update URL
			updateUrl(categoryId, subsectionId);
		});
	});

	// Accordion item toggle
	accordionHeaders.forEach(header => {
		header.addEventListener('click', () => {
			const item = header.closest('.wiki-accordion__item');
			const accordion = item.closest('.wiki-accordion');
			const isOpen = item.classList.contains('is-open');

			// Get path data
			const categoryId = accordion.getAttribute('data-category');
			const subsectionId = accordion.getAttribute('data-subsection');
			const itemSlug = item.getAttribute('data-item');

			// Close all other accordion items first
			if (!isOpen) {
				accordion.querySelectorAll('.wiki-accordion__item.is-open').forEach(openItem => {
					if (openItem !== item) {
						openItem.classList.remove('is-open');
						openItem.querySelector('.wiki-accordion__header')?.setAttribute('aria-expanded', 'false');
					}
				});
			}

			// Toggle current item
			item.classList.toggle('is-open');
			header.setAttribute('aria-expanded', !isOpen);

			// Update URL
			if (!isOpen) {
				// Opening item - include item in URL
				updateUrl(categoryId, subsectionId, itemSlug);
			} else {
				// Closing item - remove item from URL
				updateUrl(categoryId, subsectionId);
			}
		});
	});

	// Handle URL hash on page load
	const hash = window.location.hash.slice(1);
	if (hash) {
		const parts = hash.split('/');
		const categoryId = parts[0];
		const subsectionId = parts[1];
		const itemSlug = parts[2];

		if (subsectionId) {
			const targetSection = document.getElementById(subsectionId);
			if (targetSection && targetSection.classList.contains('wiki-section')) {
				showSection(subsectionId, categoryId);

				// If item slug is present, open that accordion item
				if (itemSlug) {
					const targetItem = targetSection.querySelector(`.wiki-accordion__item[data-item="${itemSlug}"]`);
					if (targetItem) {
						targetItem.classList.add('is-open');
						targetItem.querySelector('.wiki-accordion__header')?.setAttribute('aria-expanded', 'true');

						// Scroll to item after a short delay
						setTimeout(() => {
							targetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
						}, 100);
					}
				}
			}
		}
	}
	// If no hash, landing is already visible (set in PHP with is-visible class)
}
